import React, {useEffect, useState} from 'react';
import {Grid} from "@material-ui/core";
import {Footer, SellerCard, ServiceCard, SimpleAccordion, TopNavBar} from '../../components'
import './style.scss'
import HttpService from "../../services/http.service";
import Seo from "../../components/Seo";

function ServiceResults(props) {
  //const product = props?.location?.state?.product
  const [product, setProduct] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [priceFrom, setPriceFrom] = useState('null');
  const [priceTo, setPriceTo] = useState('null');
  const [locationName, setLocationName] = useState('null');
  const [productName, setProductName] = useState(props?.location?.state?.search || 'null');
  const [categoryName, setCategoryName] = useState(props?.location?.state?.category || 'null');

  const data = [
    {id: 1, item: 'Crops & Grains'},
    {id: 1, item: 'Fruits & Vegetables'},
    {id: 1, item: 'Livestock & Dairy'},
    {id: 1, item: 'Fisheries & Aquaculture'},
    {id: 1, item: 'Agri Services & Inputs'},
  ]

  const onChangeInput = (key, value, max) => {
    return;
    if (!value || value === "")
      value = 'null'
    switch (key) {
      case 'priceRange':
        setPriceFrom(value)
        setPriceTo(max)
        break;
      case 'locationName':
        setLocationName(value)
        break;
      case 'productName':
        setProductName(value)
        break;
      case 'productCategory':
        setCategoryName(value)
        break;
      default:
        break;
    }
  }
  const resetFilter = (event) => {
    // event.preventDefault()
    let value = ''
    // setPriceRange(value)
    // setLocationName(value)
    // setProductName(value)
    // setCategoryName(value)
  }
  const onItemClick = (item) => {
    // if (item.discountCapture > 0)
      // item.priceSetByVendor = (Number(item.priceSetByVendor) - ((Number(item.priceSetByVendor) * Number(item?.discountCapture)/100)))
      props.history.push(
        {
          // pathname: `/`,
          pathname: `/serviceDetail/${item?.harvestId}`,
          state: {product: item }
        })
  }
  // useEffect(() => {
  //   HttpService.get(`marketplace/getProductByLocation/V3/productName/${categoryName}/${productName}/${locationName}/${priceFrom}/${priceTo}`).then(res => {
  //     if (res) {
  //       //console.log(res.data)
  //       setProduct(res.data)
  //       //setLoading(false)
  //     }
  //   });
  // }, [productName, locationName, categoryName, priceFrom, priceTo]);
  const [pageTitle] = useState(props?.location?.state?.category ?? 'result')
  const [allServices, setAllServices] = useState([]);
  useEffect(() => {
    HttpService.post("api/servcies/list/all").then((res) => {
      if (res) {
        //  console.log(res.data)
        setAllServices(res.data);
      }
    });
  }, [])
  // const [pageTitle] = useState('result')
  return (
    <>
      <Seo
        title="Services"
        description="Browse agricultural services on AgriLive's verified, fair marketplace for smallholder farmers."
        path="/services"
      />
      <TopNavBar
        onClick={() => {  //filter and topbar search will be disable in services section
        }}
        // onClick={(v) => onChangeInput('productName', v)}
      />

      <Grid container className='product-results-container after-navbar-container' direction='row'>
        <Grid container className='' style={{paddingTop: '2%'}} className='p-main'>
          {/*best sellers*/}
          <Grid item lg={4} md={5} className='p-main'>
            {/*<ImageSection/>*/}
            <Grid  hidden={true} className='pt-20 pl-20' style={{opacity: .4,}}>
              <h2 className='heading-color font-30 mb-20 '>Filter Option</h2>
              <SimpleAccordion type={'checkbox'} title=' by category' value={categoryName} defaultExpanded={false}
                               onchange={(value) => onChangeInput('productCategory', value)} itemsList={data}/>
              <SimpleAccordion type='location' title='Location' defaultExpanded={false}
                               onchange={(value) => onChangeInput('locationName', value)} itemsList={data}/>
              <SimpleAccordion type='productName' title='product Name' defaultExpanded={false}
                               onchange={(value) => onChangeInput('productName', value)} itemsList={data}/>
              <SimpleAccordion type='price' title='price range' defaultExpanded={false}
                               onchange={(min, max) => onChangeInput('priceRange', min, max)}
                               itemsList={data}/>
              <div className='display-flex align-items-center flex-wrap justify-content-between full-width mt-20 mb-20'>
                <button className='buy-btn black-color border-none pt-5 pb-5' style={{padding: 10}}
                        onClick={resetFilter}> reset filter
                </button>
              </div>
            </Grid>
          </Grid>

          {/*result section */}
          <Grid item lg={12} md={7}>
            <Grid container direction='' className='pt-20  '
                  style={{backgroundColor: '#fff', paddingTop: 20,}}>
              <h2 className='black-color font-30 mb-20 text-capitalize'>{pageTitle}</h2>
              <Grid className='display-flex flex-wrap ' style={{justifyContent: 'space-around'}} container lg={12}>

                {(allServices || []).map((item, index) => {
                  return (<ServiceCard pageTitle={pageTitle} key={item + index} data={item} lg={3}
                                       onClick={() => onItemClick(item)}/>)
                })
                }
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Footer/>

      </Grid>
    </>
  );
}

export default ServiceResults;
